import RoomType from '../roomType';
export default class Entry extends RoomType {
  constructor() {
    super();
    this.id = 'Entry';
    this.name = "Entré";
    this.icon = "mdi-dresser";
    this.contentTypes.options.unshift(
      {
        'id': 'shoes',
        'title': 'Skoskap',
        'active': true,
        'value': -1
      },
      {
        'id': 'cabinet',
        'title': 'Garderobeskap',
        'active': true,
        'value': -1
      },
      {
        'id': 'sliding_cabinet',
        'title': 'Skyvedørsgarderobe',
        'active': false,
        'value': -1
      },
    );
  }
}